import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const devs = config.kambalaBase;
let TOCJourneyConfigURL = {
    eq: config.kambalaSwitch
        ? config.jmwedel + devs + config.equity
        : config.jmw + config.eqedel,
    comm: config.kambalaSwitch
        ? config.jmwedel + devs + config.commodity
        : config.jmw + config.commedel,
    amo: "trade/amostatus/",
    multiquote: config.jmw + config.jmw_content + "quote/multiquote/v1",
    cancelAmoOrder: config.jmw + config.equity + "trade/amo/canceltrade",
    cancelPlaceOrder: config.jmw + config.equity + "trade/canceltrade",
    cancelEsipOrder: config.jmw + config.equity + "trade/cancelsip",
    modifyAmoOrder: config.jmw + config.equity + "trade/amo/modifytrade",
    modifyOrder: config.jmw + config.equity + "trade/modifytrade",
    placeNormalTrade: config.jmwedel + devs + config.equity + "trade/placetrade/v1",
    orderDetails: config.jmwedel + devs + config.equity + "orderdetails/",
    orderDetailsComm: config.jmwedel + devs + config.commodity + "orderdetails/",
    checkMargin: config.jmwedel + devs + config.equity + "limits/checkmargin",
    brokerCharges: config.jmwedel + devs + config.equity + "trade/brokerage",
    rmsSubLimits: config.jmwedel + devs + config.equity + "limits/rmssublimits",
    limits: config.jmwedel + devs + config.commodity + "limits",
    rmsHolding: config.jmwedel + devs + config.equity + "holdings/rmsholdings",
    tpin: config.jmwedel + devs + config.equity + "edis/tpin",
    amoTrade: config.jmwedel + devs + config.equity + "trade/amo/placetrade",
    bracketOrder: config.jmwedel + devs + config.equity + "trade/placebrackettrade/v1",
    esipOrder: config.jmwedel + devs + config.equity + "trade/placesip",
    authorize: config.jmwedel + devs + config.equity + "edis/authorize",
    brokerChargesComm: config.jmwedel + devs + config.commodity + "trade/brokerage",
    placeTradeComm: config.jmwedel + devs + config.commodity + "trade/placetrade",
    amoTradeComm: config.jmwedel + devs + config.commodity + "trade/amo/placetrade",
    MFPurchase: config.jmw + config.jmw_market_env + config.jmw_market + "mf/getSchemeDetailsByCode",
    NfoPurchase: config.jmw + config.appClient + "mf/getSchemeDetails/nfo",
    MFHolding: config.jmw + config.jmw_mf + "holding",
    sipFrequency: config.jmw + config.jmw_mf + "sip/freq",
    mfStartDate: config.jmw + config.jmw_mf + "sip/startdate",
    mfPurchaseOrder: config.jmw + config.jmw_mf + "trade",
    PlaceOfsTrade: config.jmw + config.equity + "ofs/placetrade",
    upiList: config.jmw + config.edelmw_nse + "ipo/upilist",
    specificIPO: config.jmw + config.jmw_market_env + config.jmw_market + "ipo/specific",
    applyIPO: config.jmw + config.edelmw_nse + "ipo/apply",
    userStatus: config.jmw + config.edelmw_nse + "ipo/registration/status",
    ipoOtpLeads: config.jmwedel + config.jmw_content + "otp/leads",
    ipoBankMaster: config.jmwedel + config.jmw_conten_no_revamp + "admin/ipo/bank/master",
    ipoOtpValidate: config.jmwedel + config.jmw_content + "otp/validate/ipo",
    ipoOtpRegister: config.jmwedel + config.jmw_content + "otp/register/ipo",
    ipoCancel: config.jmwedel + config.edelmw_nse + "nse/ipo/cancel",
};
export default TOCJourneyConfigURL;
